import React from 'react';
import { PodcastCardProps } from '../types/types';

const PodcastCard: React.FC<PodcastCardProps> = ({ title, tag, buttonLabel, duration, imageUrl, tagUrl, url }) => {
  return (
    <div className="life-podcast-card">
      <a href={url} className="life-podcast-card__image-wrapper">
        <img className="life-podcast-card__image" src={imageUrl} alt="podcast cover" />
      </a>

      <div className="life-podcast-card__content">
        <div>
          <a href={tagUrl} className="life-podcast-card__tag tag tag-text">
            {tag}
          </a>
          <a href={url} className="life-heading-wrapper-link">
            <h6 className="">{title}</h6>
          </a>
        </div>

        <button className="life-podcast-card__button button button--secondary">{`${buttonLabel} (${duration})`}</button>

        <button className="life-podcast-card__link link-underline-14">{`${buttonLabel} (${duration})`}</button>
      </div>
    </div>
  );
};

export default PodcastCard;
